/**
 * Enable Insider new Terms and Conditions for approval.
 */
export const INSIDER_TERMS_AND_CONDITIONS_ENABLED_231101 = 'INSIDER_TERMS_AND_CONDITIONS_ENABLED_231101';
